import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { theme } from "@/components/Elements/theme";
import { QueryClient, QueryClientProvider } from 'react-query';
const queryClient = new QueryClient(); 

ReactDOM.render(
   <ThemeProvider theme={theme}>
    <QueryClientProvider client={queryClient}> 
      <React.StrictMode>
        <App />
      </React.StrictMode>
     
    </QueryClientProvider>
  </ThemeProvider>,
  document.getElementById('root')
);


reportWebVitals();
